<template>
    <div class="content">
        <div class="flist">
            <div class="d_box">
                <div class="title">基本信息</div>
                <div class="row-between">
                    <van-cell-group class="flex1">
                        <van-cell class="dlin" :title="'姓名：'+(form.realName || '')" />
                        <van-cell class="dlin" :title="'性别：'+(form.sex==1?'男':form.sex==2?'女':'')" />
                        <van-cell class="dlin" :title="'年龄：'+(form.age || '')" />
                        <van-cell class="dlin" :title="'生日：'+(form.birthday || '')" />
                    </van-cell-group>
                    <img :src="form.idPhotoImg" alt="" class="headimg" @click="geshow(form.idPhotoImg)"/>
                </div>
                <van-cell-group>
                    <van-cell class="dlin" :title="'籍贯：'+(form.nativePlace || '')"/>
                    <van-cell class="dlin" :title="'手机号：'+(form.mobile || '')"/>
                    <van-cell class="dlin" :title="'身份证号：'+(form.idCardNo || '')" />
                    <van-cell class="dlin" :title="'现住址：'+(form.currentAddr || '')" />
                    <van-cell :title="'备注：'+(form.memo || '')" />
                </van-cell-group>
            </div>

            <div class="d_box" v-for="(item,index) in form.ledgerShopList" :key="index">
                <div class="title row-between">就职单位<span>{{item.shopName}}</span></div>
                
                <van-cell-group>
                    <van-cell class="dlin" :title="'领取胸卡：'+(item.chestStatus==1?'未领取':item.chestStatus==2?'临时胸卡':item.chestStatus==3?'正式胸卡':'')" />
                    <van-cell class="dlin" :title="'是否已缴押金：'+(item.depositStatus==1?'未交':item.depositStatus==2?'已交':'')" />
                    <van-cell class="dlin" :title="'押金单据编号：'+(item.depositNo || '')" />
                    <van-cell class="w50" :class="{'dlin':index<form.ledgerShopList.length-1}" :title="'办卡时间：'+(item.takeCardTime || '')" />
                    <van-cell class="w50" :class="{'dlin':index<form.ledgerShopList.length-1}" :title="'退卡时间：'+(item.cancelCardTime || '')" />
                </van-cell-group>
                <div class="bline" v-for="(otem,nindex) in item.ledgerShopBrandList" :key="nindex">
                    <div class="title">就职品牌</div>
                    <van-cell-group>
                        <van-cell class="dlin" :title="'品牌：'+(otem.brandName || '')" />
                        <van-cell class="dlin" :title="'职位：'+(otem.position || '')" />
                        <van-cell class="dlin" :title="'工作类型：'+(otem.jobType==1?'商户员工':otem.jobType==2?'外保人员':otem.jobType==3?'三方公司员工':'')" />
                        <van-cell class="w50" :title="'绑定时间：'+(otem.joinTime || '')" />
                        <van-cell class="w50" :title="'解绑时间：'+(otem.quitTime || '')" />
                    </van-cell-group>
                </div>
            </div>

            <div class="d_box">
                <div class="title">紧急联系人</div>
                <van-cell-group>
                    <van-cell class="dlin" :title="'紧急联系人：'+(form.memberName || '')" />
                    <van-cell class="dlin" :title="'与紧急联系人关系：'+(form.memberRelation || '')" />
                    <van-cell :title="'紧急联系人电话：'+(form.memberMobile || '')"/>
                </van-cell-group>
            </div>
            <div class="d_box">
                <div class="title">附件</div>
                <van-cell-group>
                    <div class="tit">身份证人脸照/护照内页</div>
                    <van-field readonly :label-width="0">
                        <template #input>
                            <van-uploader disabled :deletable="false" v-model="idCardFaceImg" :max-count="1" />
                        </template>
                    </van-field>
                    <div class="tit">身份证国徽照/护照内页</div>
                    <van-field readonly :label-width="0">
                        <template #input>
                            <van-uploader disabled :deletable="false" v-model="idCardEmblemImg" :max-count="1" />
                        </template>
                    </van-field>
                    <van-field readonly v-model="form.patrolStatus" label="电子合同">
                        <template #input v-if="form.electronicContract && form.electronicContract!='' && form.electronicContract!=null">
                            <van-button icon="plus" type="primary" size="small" @click="show=true">预览</van-button>
                        </template>
                    </van-field>
                </van-cell-group>
            </div>
            
        </div>
        <van-popup v-model="show" position="center" :closeable="true" :style="{width:'80%',height: '60%' }">
            <iframe :src="'https://view.xdocin.com/view?src='+form.electronicContract" style="width: 100%;height: 100%" frameborder="0" />
        </van-popup>
    </div>
    
</template>

<script>
import wx from 'weixin-js-sdk'
import * as imageConversion from 'image-conversion';
import * as Minio from 'minio';
import axios from "axios";
import { ImagePreview } from 'vant'
import moment from 'moment'
export default {
  name: 'ledgerdetail',
  data () {
    return{
        show:false,
        loading:false,
        id:this.$route.params.id,
        token:this.$route.params.token,
        //token:'eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiLmooHlv5flqJ8iLCJsb2dpbkxvY2F0aW9uIjoiMTA2IiwibG9naW5fdXNlcl9rZXkiOiI0YzUwYzVhZS00MDIzLTQzOWYtYjViYi00Y2EwZWVlMDQ2OGEifQ.ojA-bTWooVMpTb5BX5hQW75P6kttJu8EcdkT7FvM4t25ttUbFj63Sb126I0RhFibkEEe6Xr-A70kdRD1dp4oYw',
        form:'',
        idCardFaceImg:[],
        idCardEmblemImg:[],

    }
  },
  created(){
    document.title = '人员信息详情'
    if(this.id!=''){
        this.getlist()
    }
    
  },
  methods:{ 
  downfile(){
      window.open(this.form.electronicContract)
    },
    getlist(){
        let that = this
        let form={
            pageNo:1,
            pageSize:10,
            selectOperationList:[{
                field: "sid",
                operate: "like",
                value: this.id,
            }]
        }
        that.$axios.post(process.env.API_HOST+"sysmanager/applets/ledger/page",form,{
            headers:{
                userTicket:that.token
            }
        }).then((res) => {
            if(res.data.state==200){
                that.form=res.data.data.list.length>0?res.data.data.list[0]:''
                that.form.age=that.form.birthday!=''?that.getages1(that.form.birthday):that.form.idCardType==1?that.getages(that.form.idCard):''
                that.form.birthday=that.form.birthday!=''?moment(that.form.birthday).format('YYYY-MM-DD'):''
                that.idCardFaceImg=that.form.idCardFaceImg &&  that.form.idCardFaceImg!='' && that.form.idCardFaceImg!=null?[{
                    url:that.form.idCardFaceImg,
                }]:[]
                that.idCardEmblemImg=that.form.idCardEmblemImg &&  that.form.idCardEmblemImg!='' && that.form.idCardEmblemImg!=null?[{
                    url:that.form.idCardEmblemImg,
                }]:[]
            }else {
                that.$toast(res.data.message)
            }
        })			
    },
    getages(id){
      let myDate = new Date(); 
      let age = myDate.getFullYear() - id.substring(6, 10); 
      return age
    },
    getages1(id){
      let myDate = new Date(); 
      let age = myDate.getFullYear() - moment(id).format('YYYY'); 
      return age
    },
    geshow(img){
      ImagePreview({
        images: [img],
        startPosition: 0,
        onClose() {
        }
      })
    },
  }
}
</script>

<style>
body{
    background: #fff;
}
</style>
<style scoped>
.row-end{
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
}
.row-between{
    display: flex;
    justify-content: space-between;
}
.flex1{
    flex: 1;
}

.flist{
    /* width: 100; */
    margin: 0.2rem auto 0;
    border-radius: 0.2rem;
    box-sizing: border-box;
    padding: 0.2rem 0.4rem 0;
}
.d_box{
    width: 100%;
    margin-top: 0.2rem;
    border-radius: 0.2rem;
    box-sizing: border-box;
    background: #E8EBEF;
    overflow: hidden;
    position: relative;
}
.d_box .title{
    position: relative;
    font-size: 0.42rem;
    font-weight: bold;
    border-bottom: 0.02rem solid rgba(0, 0, 0, 0.2);
    box-sizing: border-box;
    padding: 0.3rem 0.5rem;
}
.d_box .title::after{
    position: absolute;
    content: "";
    width: 0.12rem;
    height: 0.5rem;
    background: #6236FF;
    left: 0.2rem;
    top: 50%;
    margin-top: -0.25rem;
    border-radius: 0.18rem;
}
.d_box .tit{
    font-size: 14px;
    padding: 10px 16px 0;
}
.d_box >>> .van-cell-group,.d_box >>> .van-cell{
  background: #E8EBEF;
}
.d_box >>> .van-field__label,.d_box >>> .van-field__control{
    color: #303133;
}
.d_box >>> .van-uploader__preview-image,.d_box >>> .van-uploader__upload{
    width: 214px;
    height: 135px;
}
.d_box >>> .van-uploader__wrapper--disabled{
    opacity: 1;
}
.d_box >>> .van-cell__value{
    color: #323233;
    flex: 3;
    text-align: left;
}
.headimg{
    width: 100px;
    height: 140px;
    margin: 0.3rem;
    background: #fff;
}
.dlin{
  border-bottom: 1px dashed rgba(0, 0, 0, .4);
}
>>> .van-cell-group{
    display: flex;
    flex-wrap: wrap;
}
.bline{
    border-top: 0.2rem solid #fff;
}
/* .bline .dlin:last-child,.bline .dlin:nth-last-child(2){
    border-bottom:none;
} */
.w50{
    width: 50%;
}
</style>


// WEBPACK FOOTER //
// src/view/ledgerdetail.vue